import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-slide-out',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './slide-out.component.html',
    styleUrl: './slide-out.component.scss',
})
export class SlideOutComponent {
    @Output() public readonly isShowing: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() public slideOut: boolean | undefined;

    @HostListener('window:keyup.esc', ['$event'])
    public escape(): void {
        this.slideOut ? this.slideIn() : null;
    }

    @HostListener('click', ['$event.target'])
    public overlay(e: Element): void {
        e.classList.contains('overlay') ? this.slideIn() : null;
    }

    public slideIn(): void {
        this.slideOut = false;
        this.isShowing.emit(false);
    }
}
